'use client';

import { ReactNode } from 'react';

import { zendesk } from '@flipster/features/src/shared/zendesk/url';
import { FormattedMessage } from '@flipster/i18n';
import { NoSSR } from '@flipster/react/misc/lifecycle/NoSSR';
import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { Link } from '@flipster/ui';
import ChevronRightIcon from '@flipster/ui/assets/svgs/chevron-right.svg';

export const Faq = () => {
  const contents: { title: ReactNode; desc: ReactNode }[] = [
    {
      title: <FormattedMessage id='Earn.r260120.Flipster_earn_faq_1_title' />,
      desc: (
        <p>
          <FormattedMessage id='Earn.r260903.Flipster_earn_faq_update' />
        </p>
      ),
    },
    {
      title: <FormattedMessage id='Autogen_common.r251126.s_Faq_2' />,
      desc: (
        <div>
          <p>
            <FormattedMessage id='Earn.r260220.Flipster_earn_faq_how_are_my_daily_earnings_determined_desc_1' />
          </p>
        </div>
      ),
    },
    {
      title: <FormattedMessage id='Autogen_common.r251126.s_What_is_USDE_Earn' />,
      desc: (
        <div>
          <p>
            <FormattedMessage id='Autogen_common.r251126.s_USDE_Earn_lets_you_earn_reward_without_lock_in_allowing_you_to_trade_while_earning' />
            <br />
            <br />
            <FormattedMessage id='Autogen_common.r251126.s_You_can_get_USDE_by_minting_with_USDT_USDC_on_Flipster_take_about_30m_or_by_depositing_USDE_from_another_exchange_or_wallet' />
            <br />
            <br />
            <FormattedMessage id='Autogen_common.r251126.s_Rewards_come_from_a_promotional_program_between_Ethena_and_Flipster_and_the_base_APR_is_updated_weekly' />
          </p>
          <br />
          <span className={css({ textStyle: 'Text/M/Strong' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Note_colon' />
          </span>
          <br />
          <ul>
            <li>
              <FormattedMessage id='Autogen_common.r251126.s_A_0_07_service_fee_applies_to_both_minting_and_redeeming_An_additional_internal_processing_gas_fee_may_also_be_deducted' />
            </li>
            <li>
              <FormattedMessage id='Autogen_common.r251126.s_Minting_and_redemption_involve_withdrawals_and_deposits_to_from_Ethena_s_wallet' />
            </li>
            <li>
              • <FormattedMessage id='Autogen_common.r251126.s_For_full_terms_please_refer_to_our' />
              <NoSSR>
                <Link
                  className={css({ textStyle: 'Text/M/Underline' })}
                  href={zendesk.getUrl('USDeEarnTerms')}
                  external
                  opener
                >
                  <FormattedMessage id='Autogen_common.r251126.s_terms_and_conditions' />
                </Link>
              </NoSSR>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <section>
      <h2 className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>FAQ</h2>
      <div className={flex({ direction: 'column', gap: 8, mt: 16 })}>
        {contents.map((content, index) => (
          <details key={index} className={css({ bg: 'background.default.level-1', rounded: 8 })}>
            <summary
              className={flex({
                justify: 'space-between',
                align: 'center',
                py: 16,
                px: 20,
                cursor: 'pointer',
                textStyle: 'Text/L/Strong',
                color: 'content.default.level-5',
                'details[open] &': { pb: 0 },
              })}
              role='button'
              tabIndex={0}
            >
              <h3>{content.title}</h3>
              <ChevronRightIcon
                className={css({
                  color: 'content.default.level-2',
                  transform: 'rotate(90deg)',
                  'details[open] &': { transform: 'rotate(-90deg)' },
                })}
              />
            </summary>
            <div
              className={css({
                textStyle: 'Text/M/Regular',
                color: 'content.default.level-3',
                mt: [12, 16],
                padding: '0 20px 16px',
                whiteSpace: 'pre-wrap',
              })}
            >
              {content.desc}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
};
